module.exports = __webpack_public_path__ + "fonts/montserrat-black.46e8b3d.ttf";